import { SortDirection } from '@angular/material/sort';
import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class ChatUsersStateModel extends SubentityStateModel {
    filters = {
        list: [],
    };
    totalCount: number;
    sortBy: string;
    sortOrder: SortDirection;
    pageSize: number;
    pageNumber: number;

    constructor() {
        super();

        this.searchTerm = sessionStorage.getItem('chatUsersSearchTerm');
        this.sortBy = sessionStorage.getItem('chatUsersSortBy');
        this.sortOrder = sessionStorage.getItem('chatUsersSortOrder') as SortDirection;
    }
}
